import Firebase from 'firebase'
import API from './API'
import Armazenamento from './Armazenamento'

const providers = {
  google: new Firebase.auth.GoogleAuthProvider(),
  facebook: new Firebase.auth.FacebookAuthProvider()
}

const tratarDadosFirebase = () => {
  const usuario = Firebase.auth().currentUser
  const nomeCompleto = usuario.displayName
  let nome = ''
  let sobrenome = ''
  if (nomeCompleto) {
    const valores = nomeCompleto.split(' ')
    if (valores.length > 0) {
      nome = valores[0]
      valores.shift()
      sobrenome = valores.join(' ')
    }
  }
  return {
    usuario: {
      nome,
      sobrenome,
      email: usuario.email
    }
  }
}

const pegaProvider = (url) => {
  switch (url) {
    case 'google.com':
      return new Firebase.auth.GoogleAuthProvider()
    case 'facebook.com':
      return new Firebase.auth.FacebookAuthProvider()
    default:
      return null
  }
}

const pegaTokenDoFirebase = (atualizarTokenExpirado = false) => {
  return Firebase.auth().currentUser.getIdToken(atualizarTokenExpirado)
    .then(idToken => {
      Armazenamento.token.gravar(idToken)
      return idToken
    })
}

const pegarToken = () => {
  const cache = Armazenamento.token.pegar()

  if (!cache) {
    return pegaTokenDoFirebase()
  } else if (cache.expirado) {
    return pegaTokenDoFirebase(true)
  } else {
    return Promise.resolve(cache.valor)
  }
}

const entrar = (email, senha) => {
  return Firebase.auth().signInWithEmailAndPassword(email, senha)
    .then(response => {
      return buscar()
      // if (response.emailVerified) {
      //   return buscar()
      // }
      // return Promise.resolve(false)
    })
}

const registrar = (nome, email, senha) => {
  return Firebase.auth().createUserWithEmailAndPassword(email, senha)
    .then(response => {
      const usuario = Firebase.auth().currentUser
      return usuario.updateProfile({ displayName: nome })
    })
}

const _registrarNoBackend = (celular = null) => {
  const dados = tratarDadosFirebase()
  if(celular) {
    dados.usuario.contato = {}
    dados.usuario.contato.celular = celular
    dados.usuario.endereco = { fake: true }
  }
  return API.usuario.atualizar(dados)
    .then(response => {
      if (response.status === 200 && response.data) {
        console.log(response.data)
        Armazenamento.usuario.gravar(response.data)
      } else {
        Armazenamento.usuario.gravar(dados)
      }
      return response
    })
}

const buscar = () => {
  return API.usuario.buscar()
    .then(response => {
      if (response.status === 200 && response.data) {
        Armazenamento.usuario.gravar(response.data)
      }
      return Armazenamento.usuario.pegar()
    })
}

const entrarComSocial = (provider) => {
  return Firebase.auth().signInWithPopup(provider)
    .then(response => _registrarNoBackend())
    .catch(error => {
      // An error happened.
      if (error.code === 'auth/account-exists-with-different-credential') {
        // Step 2.
        // User's email already exists.
        // The pending Google credential.
        const pendingCredential = error.credential
        // The provider account's email address.
        const email = error.email
        // Get registered providers for this email.
        Firebase.auth().fetchProvidersForEmail(email).then((providers) => {
          // All cases are external providers.
          // Construct provider object for that provider.
          // TODO: implement getProviderForProviderId.
          const provider = pegaProvider(providers[0])
          // At this point, you should let the user know that he already has an account
          // but with a different provider, and let him validate the fact he wants to
          // sign in with this provider.
          // Sign in to provider. Note: browsers usually block popup triggered asynchronously,
          // so in real scenario you should ask the user to click on a "continue" button
          // that will trigger the signInWithPopup.
          Firebase.auth().signInWithPopup(provider).then((result) => {
            // Remember that the user may have signed in with an account that has a different email
            // address than the first one. This can happen as Firebase doesn't control the provider's
            // sign in flow and the user is free to login using whichever account he owns.
            // Step 4b.
            // Link to Google credential.
            // As we have access to the pending credential, we can directly call the link method.
            result.user.linkWithCredential(pendingCredential).then(() => {
              // Google account successfully linked to the existing Firebase user.
              this.$router.push({
                name: 'dashboard'
              })
            })
          })
        })
      } else {
        throw error
      }
    })
}

const sair = () => {
  return Firebase.auth().signOut().then(() => {
    Armazenamento.limpar()
    return 'Usuário deslogado'
  })
}

const enviarEmailVerificacaoAndRegisterBackEnd = (celular = null) => {
  let usuario = Firebase.auth().currentUser
  return usuario.sendEmailVerification()
    .then(() => _registrarNoBackend(celular))
}

const verificarEmail = (codigo) => {
  return Firebase.auth().applyActionCode(codigo)
}

const enviarRedefinicaoSenha = (email) => {
  return Firebase.auth().sendPasswordResetEmail(email)
}

const validarRedefinicaoSenha = (codigo) => {
  return Firebase.auth().verifyPasswordResetCode(codigo)
}

const confirmarRedefinicaoSenha = (codigo, email, senha) => {
  return Firebase.auth().confirmPasswordReset(codigo, senha)
    .then(() => {
      return entrar(email, senha)
    })
}

export default {
  buscar,
  entrar,
  entrarComSocial,
  enviarEmailVerificacaoAndRegisterBackEnd,
  providers,
  registrar,
  pegarToken,
  enviarRedefinicaoSenha,
  confirmarRedefinicaoSenha,
  validarRedefinicaoSenha,
  sair,
  verificarEmail,
  usuario: tratarDadosFirebase
}



// WEBPACK FOOTER //
// ./src/services/Autenticacao.js